import React from "react";
import { useSelector } from "react-redux";
import { selectJobDetailsSection } from "../../../redux/selectors";

const PrintPumpManifoldPiping = () => {
  const pumpManifoldPipingDetails = useSelector((state) =>
    selectJobDetailsSection(state, "pumpManifoldPiping")
  );
  const generalSpecDetails = useSelector((state) =>
    selectJobDetailsSection(state, "generalStation")
  );

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return null;
    }

    const renderedZones = new Set();

    return (
      <div>
        {details
          .filter((detail) => detail && detail.HasPiping && Object.keys(detail).length > 0)
          .map((detail, index) => {
            const generalDetail =
              generalSpecDetails.find(
                (genDetail) => genDetail.Zone === detail.Zone
              ) || {};

            const isEmpty =
              !Object.values(detail).some((value) => value) &&
              !Object.values(generalDetail).some((value) => value);

            if (isEmpty || renderedZones.has(detail.Zone)) {
              return null;
            }

            renderedZones.add(detail.Zone);

            return (
              <div className="section" key={index}>
                <table className="table table-bordered full-width">
                  <tbody>
                    <h3 className="print-zone-label">Zone: {detail.Zone}</h3>
                    {generalDetail.TrackerType === "VT" && (
                      <>
                        <tr>
                          <td className="col-md-6">
                            <table>
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Column Material VT: </strong>
                                    {detail.ColumnMaterialVT}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Distance From Bottom VT: </strong>
                                    {detail.DistanceFromBottomVT}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>HDPE Accessory For Sub Pump: </strong>
                                    {detail.HDPEAccessoryForSubPump}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Sub Pump Discharge Hose Type: </strong>
                                    {detail.SubPumpDischargeHoseType}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td className="col-md-6">
                            <table>
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Column Material ST: </strong>
                                    {detail.ColumnMaterialST}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Distance From Bottom Sub: </strong>
                                    {detail.DistanceFromBottomSub}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </>
                    )}
                    {generalDetail.TrackerType === "HC" && (
                      <>
                        <tr>
                          <td className="col-md-6">
                            <table>
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Station Inlet Valve Iso Size: </strong>
                                    {detail.StationInletValveIsoSize}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Station Inlet Iso Valve Style: </strong>
                                    {detail.StationInletIsoValveStyle}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td className="col-md-6">
                            <table>
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Station Inlet Iso Valve Operator: </strong>
                                    {detail.StationInletIsoValveOperator}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </>
                    )}
                    <tr>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <strong>Piping Material: </strong>
                                {detail.PipingMaterial}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Pipe Coating: </strong>
                                {detail.PipeCoating}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Pipe Color: </strong>
                                {detail.PipeColor === "Same as Station"
                                  ? `Same as Station (${generalDetail.Color})`
                                  : detail.PipeColor}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>PRV Size: </strong>
                                {detail.PRVSize}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>PRV Type: </strong>
                                {detail.PRVType}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Flow Meter Type: </strong>
                                {detail.FlowMeterType}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td className="col-md-6">
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <strong>Station Discharge Iso Valve Size: </strong>
                                {detail.StationDischargeIsoValveSize}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Station Discharge Iso Valve Style: </strong>
                                {detail.StationDischargeIsoValeStyle}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Station Discharge Iso Valve Operator: </strong>
                                {detail.StationDischargeIsoValveOperator}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>System Relief Piped To: </strong>
                                {detail.SystemReliefPipedTo}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Injection Taps: </strong>
                                {detail.InjectionTaps}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Station Hardware: </strong>
                                {detail.StationHardware}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  <strong>Comments:</strong>
                  <br />
                  {detail.PumpManifoldPipingComments}
                </p>
                <br className="clearfix" />
              </div>
            );
          })}
      </div>
    );
  };

  if (!pumpManifoldPipingDetails || !pumpManifoldPipingDetails.some(detail => detail.HasPiping)) {
    return null;
  }

  return (
    <div>
      <h2 className="print-section-header">Pump Manifold Piping Summary</h2>
      {renderDetails(pumpManifoldPipingDetails)}
    </div>
  );
};

export default PrintPumpManifoldPiping;
